import React, { FC, forwardRef, ReactNode } from 'react';
import classnames from 'classnames';
import { Loading } from '../Loading';

// @ts-ignore
import { MinusSquare, PlusSquare, Pulldown } from '../../../icons';

// @ts-ignore
import styles from './Pdf.scss';

type PdfContainerProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
};

export const Container: FC<PdfContainerProps> = ({ children, className, ...rest }) => (
  <div className={classnames(styles.pdfContainer, className)} {...rest}>
    {children}
  </div>
);

type PdfProps = JSX.IntrinsicElements['div'] & {
  loading?: boolean;
};

export const Pdf = forwardRef<HTMLCanvasElement, PdfProps>(({ loading = false, className }, ref) => {
  const canvsStyle = { width: 'auto', height: '100%' };
  return (
    <div className={classnames(styles.pdf, className)}>
      {loading ? <Loading className={styles.loading} /> : <canvas style={canvsStyle} ref={ref} />}
    </div>
  );
});

type ControllerContainerProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
};

export const ControllerContainer: FC<ControllerContainerProps> = ({ children, className, ...props }) => {
  return (
    <div className={classnames(styles.controllerContainer, className)} {...props}>
      {children}
    </div>
  );
};

type ControllerProps = JSX.IntrinsicElements['div'] & {
  page: number;
  numPages?: number;
  zoom: number;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onPrevious: () => void;
  onNext: () => void;
};

export const Controller: FC<ControllerProps> = ({
  page,
  numPages = 0,
  zoom,
  onZoomOut,
  onZoomIn,
  onPrevious,
  onNext,
  className,
}) => (
  <div className={classnames(styles.controller, className)}>
    <div className={styles.controlItem}>
      <button type="button" onClick={onZoomOut}>
        <MinusSquare size={20} />
      </button>
      <span className={styles.scale}>{zoom}％</span>
      <button type="button" onClick={onZoomIn}>
        <PlusSquare size={20} />
      </button>
    </div>

    <div className={styles.controlItem}>
      <button type="button" className={styles.prevPage} onClick={onPrevious}>
        <Pulldown size={12} />
      </button>
      <span className={styles.totalPage}>
        {page} / {numPages}
      </span>
      <button type="button" onClick={onNext}>
        <Pulldown size={12} />
      </button>
    </div>
  </div>
);
